export default __webpack_public_path__ + "static/media/etcd.d11d3494.svg";